import { ApplicationForm, BiospecimenRequest, RequestFormExtended } from '../../scripts/request-form.objects';
import { UserQuery } from '../../../../../shared/entities/user-query/user-query.entities';
import { plainToClass } from "class-transformer"
import { PickListItem, JsonItem } from '../../../../../shared/entities/pick-list/pick-list.entities';
import { RecoverRequestForm } from './request-form.form';

export class RequestFormPage {
    requestform: RequestFormExtended;
    pickLists: JsonItem[];

    recoverApplication: RecoverRequestForm;

    constructor(requestFormJson: any, pickLists: any) {
        this.requestform = plainToClass(RequestFormExtended, <RequestFormExtended>requestFormJson);
        this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);

        this.recoverApplication = new RecoverRequestForm(this.requestform, this.pickLists);
    }
}